export const ERROR_MESSAGE = Object.freeze({
  UNKNOWN: 'Something went wrong!',
  EMAIL: 'Email incorrect format.',
  PASSWORD_VALIDATE: 'Incorrect password format.',
  PASSWORD: 'The password must be at least 6 characters!',
  CONFIRMED_PASSWORD: 'The confirm password must be at least 6 characters!',
  CONFIRMED_PASSWORD_NOT_MATCHING: 'Password do not match!',
  NONE_PERMISSION: 'You do not have permission to access this page!',
});

export const SUCCESS_MESSAGE = Object.freeze({
  EMAIL: 'Email format is valid!',
  PASSWORD: 'Password is valid!',
  ADD_EXERCISE: 'Added exercise successfully!',
  UPDATE_EXERCISE: 'Updated exercise successfully!',
  DELETE_EXERCISE: 'Removed exercise successfully!',
  DELETE_EXERCISES: 'Removed exercises successfully!',
  ADD_EXERCISE_TO_LESSON: 'Added exercises to lesson successfully!',
  ADD_LESSON: 'Added lesson successfully!',
  UPDATE_LESSON: 'Updated lesson successfully!',
  DELETE_LESSON: 'Removed lesson successfully!',
  DELETE_LESSONS: 'Removed lessons successfully!',
  ADD_LESSON_TO_COURSE: `Added lessons to course successfully!`,
  ADD_COURSE: 'Added course successfully!',
  UPDATE_COURSE: 'Updated course successfully!',
  DELETE_COURSE: 'Removed course successfully!',
  DELETE_COURSES: 'Removed courses successfully!',
  ADD_FUNCTIONAL_TEST: 'Added functional test successfully!',
  DELETE_FUNCTIONAL_TEST: 'Removed functional test successfully!',
  UPDATE_FUNCTIONAL_TEST: 'Updated functional test successfully!',
  ADD_ASSESSMENT: 'Added assessment successfully!',
  UPDATE_ASSESSMENT: 'Updated assessment successfully!',
  DELETE_ASSESSMENT: 'Removed assessment successfully!',
  ADD_FUNCTIONAL_TEST_TO_ASSESSMENT: 'Added functional test to assessment successfully!',
  UPDATE_ADMIN: 'Updated admin user successfully!',
  UPDATED_SCHEDULES: 'Updated schedules successfully!',
  UPDATED_PERMISSIONS: 'Updated role permissions successfully!',
});
